/**
 * display接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const displayEndpoints: ApiEndpoint[] = [
  {
    id: 'display-create',
    method: 'POST',
    path: '/api/displays',
    name: '创建显示配置',
    description: '为空间添加显示配置',
    category: API_CATEGORIES.DISPLAY,
    bodyParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' },
      { name: 'scene', type: 'string', required: true, description: '场景名称（1-100字符）' },
      { name: 'style', type: 'object', required: true, description: '样式配置对象' },
      { name: 'icon', type: 'string', required: false, description: '图标URL' },
      { name: 'label', type: 'object', required: false, description: '标签配置对象' },
      { name: 'isDefault', type: 'boolean', required: false, description: '是否默认配置', example: 'false' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '创建的显示配置' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:display:view'
  },
  {
    id: 'display-space',
    method: 'GET',
    path: '/api/displays/space/:spaceId',
    name: '获取空间显示配置',
    description: '获取指定空间的所有显示配置',
    category: API_CATEGORIES.DISPLAY,
    pathParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '显示配置列表' }
    ]
  },
  {
    id: 'display-default',
    method: 'GET',
    path: '/api/displays/space/:spaceId/default',
    name: '获取空间默认显示配置',
    description: '获取指定空间的默认显示配置',
    category: API_CATEGORIES.DISPLAY,
    pathParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '默认显示配置' }
    ]
  },
  {
    id: 'display-update',
    method: 'PUT',
    path: '/api/displays/:id',
    name: '更新显示配置',
    description: '更新显示配置',
    category: API_CATEGORIES.DISPLAY,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '显示配置ID（UUID）' }
    ],
    bodyParams: [
      { name: 'scene', type: 'string', required: false, description: '场景名称' },
      { name: 'style', type: 'object', required: false, description: '样式配置对象' },
      { name: 'icon', type: 'string', required: false, description: '图标URL' },
      { name: 'label', type: 'object', required: false, description: '标签配置对象' },
      { name: 'isDefault', type: 'boolean', required: false, description: '是否默认配置' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '更新后的显示配置' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:display:view'
  },
  {
    id: 'display-delete',
    method: 'DELETE',
    path: '/api/displays/:id',
    name: '删除显示配置',
    description: '删除显示配置',
    category: API_CATEGORIES.DISPLAY,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '显示配置ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:display:view'
  },
  {
    id: 'display-batch-update',
    method: 'POST',
    path: '/api/displays/space/:spaceId/batch',
    name: '批量更新显示配置',
    description: '批量更新空间的显示配置',
    category: API_CATEGORIES.DISPLAY,
    pathParams: [
      { name: 'spaceId', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    bodyParams: [
      { name: 'displays', type: 'array', required: true, description: '显示配置数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '更新后的显示配置列表' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:display:view'
  },
  {
    id: 'display-scenes',
    method: 'GET',
    path: '/api/displays/scenes',
    name: '获取场景列表',
    description: '获取所有可用的场景列表',
    category: API_CATEGORIES.DISPLAY,
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '场景列表' }
    ]
  },
];
